import React from 'react';
import './listTileSkeleton.scss';

const ListTileSkeleton = () => {
   return (
      <div className="skeleton-chat-item ct-flex ct-aiStart ct-gap12">
         <div className="skeleton-avatar skeleton-box" />
         <div className="skeleton-chat-info ct-flex1 ct-flex ct-fcol ct-gap6">
            <div className="skeleton-chat-header ct-flex ct-aiCenter ct-jcBetween">
               <div className="skeleton-chat-name skeleton-box" />
               <div className="skeleton-chat-time skeleton-box" />
            </div>
            <div className="skeleton-chat-message ct-flex ct-aiCenter ct-gap8">
               <div className="skeleton-message skeleton-box" />
            </div>
         </div>
      </div>
   );
};

export default ListTileSkeleton;
